export default __webpack_public_path__ + "static/media/twoguys.ac58adba.jpg";